import { FC, useEffect, useRef, useState } from "react";
import { ChatWindowTitle } from "./ChatWindowTitle";
import { useChatStore } from "../../stores/ChatStore";
import { Message } from "../../interfaces/Chat/Message";
import { ChatFooter } from "./ChatFooter/ChatFooter";
import { toAbsoluteUrl } from "../../_metronic/helpers";
import { LogWidget } from "../Pipelines/Logs/LogWidget";
import { AddPipeline } from "../Pipelines/AddPipeline";
import Swal from "sweetalert2";
import { AddMerchant } from "../Merchants/AddMerchant";
import { ChatMessageList } from '../../components/Chat/ChatMessage/ChatMessageList'
import { ChatAttachmentModal } from "./ChatAttachmentModal";
import storage from "../../db";
import moment from 'moment';
import useUser from "../../hooks/User";
import { MasterLog } from "../Pipelines/Logs/MasterLog";
import { DetailContactChat } from "./DetailContact";
import ForwardFooter from "./ChatFooter/ForwardFooter";
import { ChatInput } from "./ChatFooter/ChatInput";
import { useSettingsStore } from "../../stores/SettingsStore";
import { isViewOnlyChat, sortListChat } from "../../functions/chat";
import { set } from "date-fns";
import { RecentChatHistory, RecentChatHistoryPipeline } from "../../interfaces/Chat/RecentChatHistory";
import { ChatMerchant } from "../../interfaces/Chat/Chat";
import { AddLog } from "../Pipelines/Logs/AddLog";
import { Product } from "../../interfaces/Product";
import { usePipelineStore } from "../../stores/PipelineStore";
import useSWR from "swr";
import axios from "axios";
import useAccessToken from "../../hooks/AccessToken";
import { Pipeline } from "../../interfaces";
import { object } from "yup";

interface Props {
    handleIntSync: (isFirst: boolean) => void
}

const ChatWindow: FC<Props> = ({ handleIntSync }) => {
    const {
        socket, showChat, setShowChat,
        phoneNumber, messages, setMessages,
        isLoading, selectedChatPhone,
        setListChatMessages, setListChatRooms, setPhoneNumber,
        chatSelectedPipeline, listChatRooms,
        attachmentMessageId, attachmentUrl, setMessagesIsSyncing,
        isOpenDetailContact, setIsOpenDetailContact, isOpenCheckBoxForward, setIsOpenCheckBoxForward
    } = useChatStore()
    const user = useUser()
    const token = useAccessToken()
    const { multiPipelines, selectMultiPipeline, setSimplePipelines, setSimplePipelineLoading, setSelectMultiPipeline } = usePipelineStore()
    const logsModalRef = useRef<HTMLDivElement | null>(null);
    const { settings } = useSettingsStore()
    const [isMobile, setIsMobile] = useState<boolean>(false);
    const [dataChatPipeline, setDataChatPipeline] = useState<Pipeline | null>(null);
    const [showAddLogModal, setShowAddLogModal] = useState<boolean>(false);

    const fetcher = (url: string) => axios.get(url, {
        headers: {
            'X-Auth-token': token
        }
    }).then(res => res.data.data)

    const API_URL = process.env.REACT_APP_API_URL
    const { data: detailPipeline = {}, error: detailPipelineError, isLoading: detailPipelineLoading } = useSWR((chatSelectedPipeline && Object.keys(chatSelectedPipeline).length > 0) ? `${API_URL}v2/lead/${chatSelectedPipeline.id}` : null, fetcher, { revalidateOnFocus: false, revalidateOnReconnect: false })

    useEffect(() => {
        socket.on("editChat", (message_id: string, new_message: string, as: string, phone: string) => {
            const { listChatMessages } = useChatStore.getState();
            let tempChatMessages = { ...listChatMessages };
            const key = `${phone}-${as}`;
            const indexMessage = tempChatMessages[key]?.findIndex((chat) => chat.id === message_id)
            const updateAt = moment().format("YYYY-MM-DD HH:mm:ss")

            setMessages((prevMessages) => {
                if (!prevMessages[indexMessage]) return prevMessages; // Hindari error jika index tidak valid

                if (phoneNumber === key) {
                    const updatedMessages = [...prevMessages]
                    updatedMessages[indexMessage].message = new_message
                    updatedMessages[indexMessage].action = { isEditing: false }
                    updatedMessages[indexMessage].updatedAt = updateAt

                    return updatedMessages;
                }

                return prevMessages;
            });

            setListChatRooms((prevMessages) => {
                if (!prevMessages) return prevMessages; // Hindari error jika index tidak valid

                const updatedMessages = { ...prevMessages }
                if (phoneNumber === key && updatedMessages[key].chat.id === message_id) {
                    updatedMessages[key].chat.message = new_message;
                    updatedMessages[key].chat.action = { isEditing: false }
                    updatedMessages[key].chat.updatedAt = updateAt

                    return updatedMessages;
                }

                return prevMessages;
            })

            setListChatMessages((prevMessages) => {
                if (!prevMessages[key][indexMessage]) return prevMessages; // Hindari error jika index tidak valid

                const updatedMessages = { ...prevMessages }
                updatedMessages[key][indexMessage].message = new_message
                updatedMessages[key][indexMessage].action = { isEditing: false }
                updatedMessages[key][indexMessage].updatedAt = updateAt

                return updatedMessages;
            })
        })

        return () => {
            socket.off("editChat");
        };
    }, [messages])

    useEffect(() => {
        socket.on("unsendChat", (message_id: string, as: string, phone: string) => {
            const { listChatMessages } = useChatStore.getState();
            const key = `${phone}-${as}`;
            const updateMessages = listChatMessages[key].filter((message) => message.id !== message_id)
            setMessages(() => updateMessages)
            setListChatMessages((prevMessages) => ({
                ...prevMessages,
                [key]: updateMessages
            }))
            setListChatRooms((prevMessages) => ({
                ...prevMessages,
                [key]: {
                    ...prevMessages[key],
                    chat: updateMessages[updateMessages.length - 1]
                }
            }))
        })

        return () => {
            socket.off("unsendChat");
        };
    }, [messages])

    useEffect(() => {
        if (!detailPipelineLoading && chatSelectedPipeline && Object.keys(detailPipeline).length > 0 && Object.keys(chatSelectedPipeline).length > 0) {
            setDataChatPipeline(detailPipeline)
            
            let data = multiPipelines.find(item => item.id === chatSelectedPipeline.template.id)
            if (data) setSelectMultiPipeline(data)
            else setDataChatPipeline(null)
        } else {
            setDataChatPipeline(null)
        }
    }, [chatSelectedPipeline, multiPipelines, detailPipeline])

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 765) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        };

        // Initial check
        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleBackButton = () => {
        setPhoneNumber('')
        setShowChat(false)
    }

    return (
        <div className="row">
            <div className={`card card-custom ${isMobile && isOpenDetailContact ? "d-none" : isOpenDetailContact ? "col-md-6 col-lg-6 col-xl-7" : "col-12"}`} style={{ maxHeight: "calc(100vh - 1rem)", height: "calc(100vh - 1rem)" }}>
                <div className="card-header p-2" style={{position: 'sticky', top: '0', zIndex: 1, minHeight: 'fit-content', height: '100%', maxHeight: 'fit-content', backgroundColor: 'white'}}>
                    <div className="row w-100" style={{height: 'fit-content', backgroundColor: 'white'}}>
                        {
                            !isViewOnlyChat(selectedChatPhone) ?
                                <>
                                    <div className="col-10 col-xl-11 d-flex">
                                        <i className="fas fa-arrow-circle-left d-xl-none mt-3 me-3" onClick={handleBackButton} role="button" style={{ fontSize: "25px" }}></i>
                                        <ChatWindowTitle setOpenDetailContact={setIsOpenDetailContact} />
                                    </div>
                                    <div className="col-2 col-xl-1 d-flex justify-content-end mt-1">
                                        {
                                            phoneNumber &&
                                            <div className="cursor-pointer p-2" style={{ height: "fit-content" }} data-bs-toggle="modal" data-bs-target={`${listChatRooms[phoneNumber].merchants?.length !== 0 ? '#add-pipeline-modal' : '#add-merchant-modal'}`} >
                                                <i className="fas fa-plus fs-3 text-hover-primary"></i>
                                            </div>
                                        }
                                        {
                                            phoneNumber && dataChatPipeline !== null &&
                                            <div className="cursor-pointer p-2" style={{ height: "fit-content" }} data-bs-toggle="modal" data-bs-target="#logs-modal" >
                                                <i className="fas fa-book fs-3 text-hover-primary"></i>
                                            </div>
                                        }
                                    </div>
                                </>
                                :
                                <div className="col-12 d-flex">
                                    <i className="fas fa-arrow-circle-left d-xl-none mt-3 me-3" onClick={handleBackButton} role="button" style={{ fontSize: "25px" }}></i>
                                    <ChatWindowTitle setOpenDetailContact={setIsOpenDetailContact} />
                                </div>
                        }
                    </div>
                </div>
                {
                    isLoading &&
                    <div className="card-body p-0" style={{ zIndex: 1000 }}>
                        <div className="loading-overlay">
                            <div className="loader"></div>
                        </div>
                    </div>
                }

                {
                    showChat && !isLoading ?
                        <>
                            <ChatMessageList handleIntSync={handleIntSync} />
                            {
                                !isViewOnlyChat(selectedChatPhone) &&
                                <div className="card-footer" style={{ padding: "0rem 2.25rem" }}>
                                    {isOpenCheckBoxForward ? <ForwardFooter onCancel={() => setIsOpenCheckBoxForward(false)} onForward={() => { }} /> : <ChatInput />}
                                </div>
                            }
                        </>
                        :
                        <div className="card-body">
                            <div className="center-overlay">
                                <img src={toAbsoluteUrl('/media/logos/wooblazz-chat.png')} style={{ height: "20%" }} alt="" />
                            </div>
                        </div>
                }

                {
                    phoneNumber && dataChatPipeline !== null &&
                    <div className="modal fade" tabIndex={-1} id="logs-modal" ref={logsModalRef}>
                        <div className="modal-dialog modal-dialog-centered modal-xl">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <MasterLog from="chat" lead={dataChatPipeline} setShow={setShowAddLogModal} />
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {
                    phoneNumber && dataChatPipeline !== null &&
                    <AddLog showModal={showAddLogModal} setShowModal={setShowAddLogModal} lead={dataChatPipeline} showAddLogButton={false} />
                }

                {
                    phoneNumber &&
                    <AddPipeline merchantId={listChatRooms[phoneNumber].merchants.map((data: ChatMerchant) => data.id)} />
                }
                {
                    phoneNumber &&
                    <AddMerchant chatWindowData={{ name: listChatRooms[phoneNumber].roomName, phone: phoneNumber.split('-')[0], as: phoneNumber.split('-')[1] }} />
                }
                {
                    attachmentMessageId &&
                    <ChatAttachmentModal messageId={attachmentMessageId} url={attachmentUrl} />
                }
            </div>
            {
                isOpenDetailContact && <DetailContactChat />
            }
        </div>
    )
}

export { ChatWindow }